
import { MainForumTopicModel } from '../models/MainForumTopicModel.js';
import { MainForumTopicView } from '../views/MainForumTopicView.js';

export class MainForumTopicController {
    constructor() {

        this.model = new MainForumTopicModel();
        this.view = new MainForumTopicView();

        this.model.subscribe(state => this.view.render(state));
    }
}